/*
  TMA — the Add button becomes a quantity stepper once the item is in the bag.

  Why: the headline offer is "get 5 or more, save 10%". Reaching five meant
  tapping Add five times with no feedback on where you were. Now the button
  turns into − n + and the shopper can see and change the count in place.

  Progressive enhancement. The stepper ships hidden; nothing reveals it until
  this script has read the real cart, so with JavaScript off the ordinary Add
  form still posts and works.

  The cart is the source of truth, never local state: every change re-reads
  /cart.js and repaints from that. Optimistic counts drift the moment two tabs,
  a cart drawer, or a failed request disagree.
*/
(function () {
  var cards = document.querySelectorAll('[data-tma-card-step]');
  if (!cards.length || !window.fetch) return;

  var inFlight = {};

  function byVariant(id) {
    return document.querySelector('[data-tma-card-step][data-variant="' + id + '"]');
  }

  function paint(step, qty) {
    var form = step.parentElement.querySelector('form');
    if (qty > 0) {
      step.hidden = false;
      if (form) form.hidden = true;
      var count = step.querySelector('[data-step-count]');
      if (count) count.textContent = qty;
      step.setAttribute('data-qty', qty);
    } else {
      step.hidden = true;
      if (form) form.hidden = false;
      step.setAttribute('data-qty', '0');
    }
  }

  /* Repaint every card from one cart read. A product absent from the cart
     goes back to showing its Add button. */
  function sync(cart) {
    var counts = {};
    (cart.items || []).forEach(function (item) {
      counts[item.variant_id] = (counts[item.variant_id] || 0) + item.quantity;
    });
    cards.forEach(function (step) {
      paint(step, counts[step.getAttribute('data-variant')] || 0);
    });
  }

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function setQty(step, qty) {
    var variant = step.getAttribute('data-variant');
    if (inFlight[variant]) return;
    inFlight[variant] = true;
    step.classList.add('is-busy');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variant, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('change failed');
        return res.json();
      })
      .then(function (cart) {
        sync(cart);
        document.dispatchEvent(new CustomEvent('tma:cart:updated', { detail: cart }));
      })
      .catch(function () {
        /* Put the real cart back on screen rather than leaving a number that
           never happened. */
        return readCart().then(sync).catch(function () {});
      })
      .then(function () {
        inFlight[variant] = false;
        step.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-step]');
    if (!btn) return;
    var step = btn.closest('[data-tma-card-step]');
    if (!step) return;
    e.preventDefault();
    var now = parseInt(step.getAttribute('data-qty') || '0', 10);
    setQty(step, Math.max(0, now + parseInt(btn.getAttribute('data-step'), 10)));
  });

  /* tma-cart.js fires this after an Add, so the button it just used flips
     straight to a stepper without a second round trip. */
  document.addEventListener('tma:cart:updated', function (e) {
    if (e.detail) sync(e.detail);
  });

  readCart().then(sync).catch(function () {});
})();
